import React from 'react';
import './TrainingRequest.css';

function TrainingRequest() {
  return (
    <>
    {/* <div className="training-request-wrap">
        <div className="training-request-row">
            <p><a href="https://lkmportal.atci.accenture.com/LMS/Need/RaiseTrainingRequest" target="_blank"><img src="images/feedback/request-icon-v1.svg" alt="request" />Request for Training</a></p>
        </div>
    </div> */}
    </>
  )
}

export default TrainingRequest